import React from 'react';

export default function ({ highlightsfeed, eleRef }) {
    return (

        <section className="main_container_block_feeds baby_view_more">
        <div className="main_block_container_feed">
           <div className="block_container_feed_heading_text baby_name_header  pfeed_bottom_20 R15_61">
              {highlightsfeed.title?highlightsfeed.title:''}
            </div>
            <div className="main_container_block_feeds_main">
            <div className="content-div_view_artical">
                <img src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/Baby_Names_Banner.png" alt="logo"/>
            </div>
             <div className="baby_names-section">
                <div className="baby_names-tools-names_view_more">
                   {highlightsfeed.data && highlightsfeed.data.slice(0, 3).map((sugbabyname, sbabyindx) =>
                    <div key={`sbabyindx-{$sbabyindx}`}>
                    {sugbabyname.gender && sugbabyname.gender=="Girl"?
                   <div className="names_babys">
                      <div className="baby_name_left">
                        <span className="icons_baby"> <img src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/female.svg" alt="logo"/> </span>
                        <span className="R15_21"> {sugbabyname.babyname?sugbabyname.babyname:''} </span>
                      </div>
                      <div className="baby_name_right">
                        {sugbabyname.isShortlist && 
                            <span className="icons_baby"> <span data-icon-font="}" className="icon"></span> </span>
                        }
                      </div>
                   </div>:                                       

                   <div className="names_babys">
                      <div className="baby_name_left">
                        <span className="icons_baby"> <img src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/male.svg" alt="logo"/> </span>
                        <span className="R15_21"> {sugbabyname.babyname?sugbabyname.babyname:''} </span>
                      </div>
                      <div className="baby_name_right">
                        {sugbabyname.isShortlist && 
                            <span className="icons_baby"> <span data-icon-font="}" className="icon"></span> </span>
                        }
                      </div>
                   </div>
                    }
                    </div>
                   )}

                </div>
                <div className="explore_baby_names">
                <a href='https://parenting.firstcry.com/baby-names/'>
                     <button className="M16_42 gtm-babyname" type="button">View More <span data-icon-font="h" className="icon"></span></button>
                     </a>
                </div>
             </div>
            </div> 
        </div>
    </section>

    )
}
